export default {
  MBFAF00001: 'Invalid username or password.',
  MBFAF00002: 'Illegal access',
  MBFAF00003: 'Insufficient privileges',
  MBFAF00004: 'Firebase API error',
  MBFAF00005: 'Invalid new password',
};
